import { Injectable } from '@angular/core';

import { BaseChartService, HttpService } from '../../../tms-shared';

@Injectable({
  providedIn: 'root',
})
export abstract class TmsWebBaseChartService<T> extends BaseChartService<T> {
  protected constructor(
    protected baseRoute: string,
    protected httpService: HttpService,
  ) {
    super(baseRoute, httpService);
  }

  protected get apiUrl() {
    return `TmsWeb/${this.baseRoute}`;
  }
}
